/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { scrollToContent } from "../../common/scroller";

export const Nav = () => {
  const navItems = [
    { label: "Experience", id: "experience" },
    { label: "Stack", id: "stack" },
    { label: "Projects", id: "projects" },
    { label: "Contact", id: "contact" },
  ];

  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="navbar bg-white/95 backdrop-blur-md fixed top-0 z-50 shadow-md px-6">
      {/* Logo */}
      <div className="flex-1">
        <a href="#" onClick={() => scrollToContent("top")} className="btn btn-ghost normal-case text-xl text-gray-900">
          <img src="/img/me.svg" alt="Logo" className="w-10 h-10 rounded-md mr-2" />
          Tsheko
        </a>
      </div>

      {/* Desktop Menu */}
      <div className="hidden lg:flex gap-4">
        {navItems.map(({ label, id }) => (
          <button key={id} onClick={() => scrollToContent(id)} className="btn btn-ghost text-gray-700 hover:text-gray-900">
            {label}
          </button>
        ))}
        <a href="docks/Tsheko Kutumela CV Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-outline btn-sm text-gray-900 border-gray-300 hover:bg-gray-100">
          Resume
        </a>
        <button onClick={() => scrollToContent("contact")} className="btn btn-primary btn-sm text-white bg-gray-900 hover:bg-gray-800">
          Hire Me
        </button>
      </div>

      {/* Mobile Menu Button */}
      <div className="lg:hidden">
        <button className="btn btn-ghost btn-circle" onClick={() => setMobileOpen(!mobileOpen)} aria-label={mobileOpen ? "Close menu" : "Open menu"}>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-900" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {mobileOpen ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />}
          </svg>
        </button>

        {/* Mobile Dropdown */}
        {mobileOpen && (
          <ul className="menu menu-compact dropdown-content mt-2 shadow bg-white rounded-box w-52 absolute right-6 top-14 z-40">
            {navItems.map(({ label, id }) => (
              <li key={id}>
                <button
                  onClick={() => {
                    scrollToContent(id);
                    setMobileOpen(false);
                  }}
                  className="btn btn-ghost w-full text-gray-700 hover:bg-gray-100">
                  {label}
                </button>
              </li>
            ))}
            <li>
              <a href="docks/Tsheko Kutumela CV Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-outline w-full text-gray-900 hover:bg-gray-100">
                Resume
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
